export var uiArrowLeft = [
    'M8.17 13.14L8.34 12.98C8.45 12.86 8.45 12.7 8.34 12.58L4.17 8.39H12.98C13.12 8.39 13.26 8.27 13.26 8.11V7.87C13.26 7.73 13.12 7.59 12.98 7.59H4.17L8.34 3.42C8.45 3.3 8.45 3.14 8.34 3.02L8.17 2.86C8.06 2.74 7.89 2.74 7.77 2.86L2.83 7.8C2.71 7.92 2.71 8.08 2.83 8.2L7.77 13.14C7.89 13.26 8.06 13.26 8.17 13.14Z',
];
